import type { TextStyleValue } from '@elfsight/configurator-contracts';
import type { FieldStyles } from '../../types';

type StyleParameters = {
  heading: TextStyleValue;
  text: TextStyleValue;
  caption: TextStyleValue;
  fieldLabel: TextStyleValue;
  fieldValue: TextStyleValue;
  fieldStyle: 'outline' | 'filled';
};

export const fieldsStyles: Record<FieldStyles, StyleParameters> = {
  style1: {
    heading: { fontSize: 32, fontWeight: 'bold' },
    text: { fontSize: 15 },
    caption: { fontSize: 13 },
    fieldLabel: { fontSize: 15, fontWeight: 'bold' },
    fieldValue: { fontSize: 15 },
    fieldStyle: 'outline'
  },
  style2: {
    heading: { fontSize: 32, fontWeight: 'bold' },
    text: { fontSize: 15 },
    caption: { fontSize: 13 },
    fieldLabel: { fontSize: 15, fontWeight: 'normal' },
    fieldValue: { fontSize: 15, fontWeight: 'bold' },
    fieldStyle: 'outline'
  },
  style3: {
    heading: { fontSize: 32, fontWeight: 'bold' },
    text: { fontSize: 15 },
    caption: { fontSize: 13 },
    fieldLabel: { fontSize: 15, fontWeight: 'normal' },
    fieldValue: { fontSize: 15 + 3, fontWeight: 'bold' },
    fieldStyle: 'outline'
  },
  style4: {
    heading: { fontSize: 32, fontWeight: 'bold' },
    text: { fontSize: 15 },
    caption: { fontSize: 13 },
    fieldLabel: { fontSize: 15, fontWeight: 'bold' },
    fieldValue: { fontSize: 15 + 5, fontWeight: 'normal' },
    fieldStyle: 'outline'
  },
  style5: {
    heading: { fontSize: 32, fontWeight: 'bold' },
    text: { fontSize: 15 },
    caption: { fontSize: 13 },
    fieldLabel: { fontSize: 15, fontWeight: 'bold' },
    fieldValue: { fontSize: 15, fontWeight: 'normal' },
    fieldStyle: 'filled'
  },
  style6: {
    heading: { fontSize: 32, fontWeight: 'bold' },
    text: { fontSize: 15 },
    caption: { fontSize: 13 },
    fieldLabel: { fontSize: 15, fontWeight: 'normal' },
    fieldValue: { fontSize: 15, fontWeight: 'bold' },
    fieldStyle: 'filled'
  },
  style7: {
    heading: { fontSize: 32, fontWeight: 'bold' },
    text: { fontSize: 15 },
    caption: { fontSize: 13 },
    fieldLabel: { fontSize: 15, fontWeight: 'normal' },
    fieldValue: { fontSize: 15 + 3, fontWeight: 'bold' },
    fieldStyle: 'filled'
  },
  style8: {
    heading: { fontSize: 32, fontWeight: 'bold' },
    text: { fontSize: 15 },
    caption: { fontSize: 13 },
    fieldLabel: { fontSize: 15, fontWeight: 'bold' },
    fieldValue: { fontSize: 15 + 5, fontWeight: 'normal' },
    fieldStyle: 'filled'
  }
};
